import { html } from "uhtml";
import { Customised } from "../custom-element.js";
import { libHandler, locale } from "../../view-models/app-signals.js";
import { locales } from "../../models/locales.js";
import { device, settingsStore } from "../../models/Store.js";
import { signal } from "alien-signals";
import { fetchSignal } from "../../models/trackerUtilities.js";
import { showToast } from "./cassis-toast.js";

// this.token = this.getCsrfToken();

// export interface LibHandlerConfig {
//   streamer_identifier: string;
//   redirect_url: string;
//   my_books_route: string;
//   status?: number;
//   in_bookshelf?: boolean;
// }

export class CassisLibHandler extends Customised(HTMLElement) {
  static tagName = "cassis-lib";

  static OK = 200;
  static UNAUTHORIZED = 401;
  static CONFLICT = 409;
  static ERROR = 500;
  static STATE_KEY = "added-to-lib";
  sampleAdded = signal(false);
  store = settingsStore;

  connectedCallback() {
    super.connectedCallback();
    const token = document.head.querySelector("meta[name=csrf-token]");
    this.token = token ? token.content : undefined;
  }

  signals() {
    const deviceId = device.id;
    const config = libHandler();
    if (config) {
      this.parentElement.removeAttribute("hidden");
    }
    let classNames = "icon libHandler-icon";
    const added = this.sampleAdded();
    let disabled = false;
    if (added) {
      classNames = "icon libHandler-icon sample-added";
      disabled = true;
      this.store.setKeySync(CassisLibHandler.STATE_KEY, "true");
    } else {
      this.store.removeKeySync(CassisLibHandler.STATE_KEY);
    }
    return {
      config,
      locale: locale(),
      deviceId,
      classNames,
      disabled,
      fetch: fetchSignal(),
    };
  }
  handleEvent() {
    console.log("clicked on libhandler");
    this.handleRequest(this.deviceId);
  }
  render({ config, locale, deviceId, classNames, fetch, disabled }) {
    this.fetch = fetch;
    this.config = config;
    this.deviceId = deviceId;
    this.locale = locale;
    return html` <button
      id="lib-handler"
      type="button"
      aria-label="${locales.libHandler[locale]}"
      @click=${this}
      ?disabled=${disabled}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 19 19"
        preserveAspectRatio="xMidYMid meet"
        role="img"
        class="${classNames}"
        aria-labelledby="lib-icon"
      >
        <title id="lib-icon">${locales.libHandler[locale]}</title>
        <path
          d="M11.498 6.354l-.061-.009A3.63 3.63 0 0 0 7.94 3.632a3.627 3.627 0 0 0-3.521 2.812 3.15 3.15 0 0 0-3.418 3.134 3.153 3.153 0 0 0 3.111 3.148 3.15 3.15 0 0 0 3.109 2.686h7.587a3.152 3.152 0 0 0 3.148-3.146 3.152 3.152 0 0 0-3.419-3.136 3.63 3.63 0 0 0-3.039-2.776m4.764 3.816a2.55 2.55 0 0 1 1.096 2.094 2.552 2.552 0 0 1-2.547 2.549H7.222a2.552 2.552 0 0 1-2.548-2.549 2.551 2.551 0 0 1 3.009-2.505c.08.018.163-.003.229-.051s.109-.121.122-.201a3.022 3.022 0 0 1 2.981-2.588 3.023 3.023 0 0 1 2.98 2.588.302.302 0 0 0 .351.252 2.525 2.525 0 0 1 1.916.411M1.6 9.578a2.552 2.552 0 0 1 3.01-2.504.3.3 0 0 0 .351-.253 3.023 3.023 0 0 1 2.982-2.588c1.319 0 2.474.871 2.866 2.093a3.624 3.624 0 0 0-3.314 2.8 3.151 3.151 0 0 0-3.415 2.997A2.548 2.548 0 0 1 1.6 9.578z"
        ></path>
        <path
          id="libHandler-add"
          d="M17.672 4.908h-1.607V3.3a.3.3 0 0 0-.602 0v1.608h-1.607a.3.3 0 1 0 0 .6h1.607v1.609a.3.3 0 0 0 .602 0V5.508h1.607a.3.3 0 1 0 0-.6z"
        ></path>
        <path
          id="libHandler-exist"
          d="M13.697 5.051l.309.262.508.427c.002.003.004.01.006.003l-.16.655-.098.392c-.072.294.04.427.113.479.03.022.092.058.178.058a.4.4 0 0 0 .211-.067l.266-.164.722-.448c.004-.001.011-.001.005-.005l.573.355.344.213a.554.554 0 0 0 .291.096.317.317 0 0 0 .191-.06c.054-.039.172-.156.113-.394l-.08-.329-.001-.001-.19-.771c0-.003.002-.011-.003-.006l.516-.435.31-.262c.218-.184.19-.362.167-.432-.021-.068-.104-.23-.389-.25l-.404-.03-.661-.047c-.003-.001-.009-.005-.007.001l-.254-.624-.153-.375c-.108-.263-.288-.292-.36-.292-.071 0-.252.028-.358.293l-.152.375-.25.615c-.002.003-.008.008-.001.006l-.673.049-.401.03c-.285.021-.368.182-.392.25-.025.07-.054.249.164.433zm.658-.268l.672-.049a.463.463 0 0 0 .375-.272l.256-.625.1-.244.1.244.255.625a.46.46 0 0 0 .375.272l.673.049.263.02-.201.17-.516.437a.46.46 0 0 0-.145.44l.192.782.031.128-.225-.139-.572-.356a.465.465 0 0 0-.465 0l-.729.454h-.001l-.065.041.063-.256.16-.655a.457.457 0 0 0-.144-.44l-.516-.436-.201-.17.265-.02z"
        ></path>
      </svg>
      <span class="setting-text" id="lib-handler-label"
        >${locales.libHandler[locale]}</span
      >
    </button>`;
  }

  async handleRequest(deviceId) {
    const payload = {
      streamer_identifier: this.streamerIdentifier,
      s: deviceId,
    };

    if (this.token) {
      try {
        const response = await this.fetch(this.config.my_books_route, {
          method: "POST",
          body: JSON.stringify(payload),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": this.token,
          },
        });

        if (!response.ok) {
          /* c8 ignore next 2 */
          if (response.status === CassisLibHandler.UNAUTHORIZED) {
            this.handleRedirect();
          } else if (response.status === CassisLibHandler.CONFLICT) {
            this.handleConflict();
          } else {
            this.handleError();
          }
        } else {
          this.handleOK();
        } // eslint-disable-next-line
      } catch (_err) {
        this.handleError();
      }
    } else {
      this.handleError();
    }
  }
  handleOK() {
    // console.log("handle OK");
    showToast(locales.libAdded[this.locale]);
    this.sampleAdded(true);
  }

  handleConflict() {
    showToast(locales.libExists[this.locale]);
    this.sampleAdded(true);
  }

  // Handle this with popovers, a balloon over the button, instead of toasts.
  handleError() {
    showToast(locales.libError[this.locale]);
    console.log("Error adding to library");
  }

  /* c8 ignore next 3 */
  handleRedirect() {
    window.location.assign(this.redirect_url);
  }
}
CassisLibHandler.define();
